import React, { FC } from 'react';
import { Box } from '@edreamsodigeo/prisma-design-system';
import { colors } from './constants/designTokens';
import Reprice from '../Reprice/Reprice';
import useGetBuyPathDeal from 'clientState/hooks/useGetBuyPathDeal';
import { useItinerary } from '../Itinerary/Provider';
import { useFlowTools } from 'flowTools/useFlowTools';

type SxProps = {
  background?: string;
  position?: string;
};

type ItineraryDealProps = {
  borderRadius?: number;
  sx?: SxProps;
};

const ItineraryDeal: FC<ItineraryDealProps> = ({ children, ...rest }) => {
  const gradient = colors.deal.backgroundGradient;
  const dealBuyPath = useGetBuyPathDeal();
  const { trend } = useItinerary().dealInfo;
  const { isDesktop } = useFlowTools();

  return (
    <Box
      sx={{
        background: gradient,
        position: 'relative',
      }}
      borderRadius={2}
      {...rest}
    >
      {children}
      {!isDesktop && (
        <Reprice isFooter={true} trend={trend} dealBuyPath={dealBuyPath} />
      )}
    </Box>
  );
};

export default ItineraryDeal;
